import API from "../api";
import COMMON_API from "../../../api/common";
const DEFAULT_REGION_COURT = {
  id: "00000000-0000-0000-0000-000000000000",
  nome: "NÃO SE APLICA"
};
const DEFAULT_OFFICE_QUOTATION = {
  id: "00000000-0000-0000-0000-000000000000",
  nome_fantasia: "NENHUM"
};
export default {
  namespaced: true,
  state: {
    listQuotation: [],
    listQuotationAgro: [],
    listPropostaAgro: [],
    listApoliceAgro: [],
    listQuotationCostsAgro: [],
    totalQuotation: 0,
    listQuotationTeste: [
      {
        id: 1,
        numero: "34985709438",
        tomador: {
          id: 2,
          nome_fantasia: "ECSA - Escola a Chave do Saber LTDA"
        },
        status: {
          id: 0,
          nome: "Aguardando aprovação"
        },
        complainer: "ECSA - Escola a Chave do Saber LTDA",
        expira_em: "3 dias"
      },
      {
        id: 2,
        numero: "34985709438",
        tomador: {
          id: 1,
          name: "34985709438",
          nome_fantasia: "ECSA - Escola a Chave do Saber LTDA"
        },
        status: {
          id: 1,
          nome: "Apólice emitida"
        },
        complainer: "ECSA - Escola a Chave do Saber LTDA",
        expira_em: "2 dias"
      },
      {
        id: 4,
        numero: "34985709438",
        tomador: {
          id: 3,
          name: "34985709438",
          nome_fantasia: "ECSA - Escola a Chave do Saber LTDA"
        },
        status: {
          id: 2,
          nome: "Minuta emitida"
        },
        complainer: "ECSA - Escola a Chave do Saber LTDA",
        expira_em: "0 dias"
      },
      {
        id: 7,
        numero: "34985709438",
        tomador: {
          id: 20,
          name: "34985709438",
          nome_fantasia: "ECSA - Escola a Chave do Saber LTDA"
        },
        status: {
          id: "aguardando_emissao_minuta",
          nome: "Aguardando emissão de minuta"
        },
        complainer: "ECSA - Escola a Chave do Saber LTDA",
        expira_em: "1 dias"
      }
    ],
    filterQuotation: null,
    valueStepModality: {
      modality: null,
      subModality: null,
      emissionType: null
    },
    currentQuotationStep: {
      name: "1. Modalidades",
      router: "quotation step modality",
      step: 1
    },
    economicGroupQuotation: null,
    takerQuotation: null,
    insuredForm: {
      type: null,
      cpf: null,
      name: null,
      cep: null,
      address: null,
      number: null,
      complement: null,
      uf: null,
      city: null,
      neighborhood: null
    },
    resourceForm: {
      value: null,
      percent: "30%"
    },
    resourceQuotation: null,
    listEconomicGroup: [],
    listTaker: [],
    listUserTaker: [],
    listResourceType: [],
    insuredByNameOrCPFCNPJ: [],
    addressApi: [],
    statusQuotation: [
      {
        name: "1. Dados do Processo",
        id: "dados_processo"
      },
      {
        name: "2. Aguardando Cotação",
        id: "aguardando_cotacao"
      },
      {
        name: "3. Solicitar Minuta",
        id: "solicitar_minuta"
      },
      {
        name: "4. Aprovação de Minuta",
        id: "aprovacao_minuta"
      },
      {
        name: "5. Emissão de Apólice",
        id: "emissao_apolice"
      },
      {
        name: "6. Apólice Emitida",
        id: "apolice_emitida"
      }
    ],
    listModality: [],
    listSubModality: [],
    listClassificacaoSolo: [],
    eletronicProcessValue: {},
    listJusticeRegion: [],
    listCourtJustice: [],
    listDeadlineByTaker: [],
    infoCostQuotation: {},
    currentQuotation: {
      custos: []
    },
    currentQuotationAgro: {
      custos: []
    },
    currentAutoCompleteFilterQuotation: [],
    currentTakerQuotation: [],
    currentSelectFilterQuotation: [],
    insuranceCompanyOptions: [],
    listCriticism: {
      criticas: []
    },
    currentQuotationToEdit: {},
    currentYearsQuotation: [],
    currentHistoricalActions: {},
    apiCalls: [],
    itemsCriticism: {
      items: [],
      total: 0
    },
    statusCurrentQuotation: {},
    listOfficeQuotation: [],
    itemsInsuranceToEmail: [],
    currentSelectFilterRequestEndorsement: [],
    cafezalEspecieOptions: [],
    cafezalVariedadeOptions: [],
    cafezalSistemaCultivoOptions: [],
    listBankingInstitutions: []
  },
  mutations: {
    setApiCalls(state, payload) {
      state.apiCalls = payload;
    },
    setValueStepModality(state, payload) {
      state.valueStepModality = payload;
    },
    setCurrentQuotationStep(state, payload) {
      state.currentQuotationStep = payload;
    },
    setEconomicGroupQuotation(state, payload) {
      state.economicGroupQuotation = payload;
    },
    setTakerQuotation(state, payload) {
      state.takerQuotation = payload;
    },
    setInsuredForm(state, payload) {
      state.insuredForm = payload;
    },
    setResourceQuotation(state, payload) {
      state.resourceQuotation = payload;
    },
    setResourceForm(state, payload) {
      state.resourceForm = payload;
    },
    setListEconomicGroup(state, payload) {
      state.listEconomicGroup = payload;
    },
    setListTaker(state, payload) {
      state.listTaker = payload;
    },
    setListUserTaker(state, payload) {
      state.listUserTaker = payload;
    },
    updateTakerList(state, payload) {
      const index = state.listTaker.findIndex(x => x.id === payload.id);
      state.listTaker[index].favorito = !payload.favorito;
    },
    setListResourceType(state, payload) {
      state.listResourceType = payload;
    },
    setInsuredByNameOrCPFCNPJ(state, payload) {
      state.insuredByNameOrCPFCNPJ = payload;
    },
    setAddressApi(state, payload) {
      state.addressApi = payload.items;
    },
    setListQuotation(state, payload) {
      state.listQuotation = payload.items;
      state.totalQuotation = payload.total_count;
    },
    setListQuotationAgro(state, payload) {
      state.listQuotationAgro = payload.items;
      state.totalQuotation = payload.total_count;
    },
    setListPropostaAgro(state, payload) {
      state.listPropostaAgro = payload.items;
      state.totalQuotation = payload.total_count;
    },
    setListApoliceAgro(state, payload) {
      state.listApoliceAgro = payload.items;
      state.totalQuotation = payload.total_count;
    },
    setListQuotationCostsAgro(state, payload) {
      state.listQuotationCostsAgro = payload.items;
      state.totalQuotation = payload.total_count;
    },
    setListModality(state, payload) {
      state.listModality = payload;
    },
    setListSubModality(state, payload) {
      state.listSubModality = payload;
    },
    setListClassificacaoSolo(state, payload) {
      state.listClassificacaoSolo = payload;
    },
    setEletronicProcessValue(state, payload) {
      state.listJusticeRegion = [payload.tribunal];
      state.listCourtJustice = payload.unidades;
      state.listCourtJustice.push(DEFAULT_REGION_COURT);
      state.eletronicProcessValue = payload;
    },
    setListJusticeRegion(state, payload) {
      state.listJusticeRegion = payload;
    },
    setListCourtJustice(state, payload) {
      state.listCourtJustice = payload;
      state.listCourtJustice.unshift(DEFAULT_REGION_COURT);
    },
    setListDeadlineByTaker(state, payload) {
      state.listDeadlineByTaker = payload;
    },
    setInfoCostQuotation(state, payload) {
      state.infoCostQuotation = payload;
    },
    setCurrentQuotation(state, payload) {
      state.currentQuotation = payload;
    },
    setCurrentQuotationAgro(state, payload) {
      state.currentQuotationAgro = payload;
    },
    setCurrentAutoCompleteFilterQuotation(state, payload) {
      state.currentAutoCompleteFilterQuotation = payload;
    },
    setCurrentTakerQuotation(state, payload) {
      state.currentTakerQuotation = payload;
    },
    setCurrentSelectFilterQuotation(state, payload) {
      state.currentSelectFilterQuotation = payload;
    },
    setInsuranceCompanyOptions(state, payload) {
      state.insuranceCompanyOptions = payload;
    },
    setListCriticism(state, payload) {
      state.listCriticism = payload;
    },
    setCurrentQuotationToEdit(state, payload) {
      state.currentQuotationToEdit = payload;
    },
    setCurrentYearsQuotation(state, payload) {
      state.currentYearsQuotation = payload;
    },
    setCurrentHistoricalActions(state, payload) {
      state.currentHistoricalActions = payload;
    },
    setItemsCriticism(state, payload) {
      state.itemsCriticism = payload;
    },
    setStatusCurrentQuotation(state, payload) {
      state.statusCurrentQuotation = payload;
    },
    setListOfficeQuotation(state, payload) {
      state.listOfficeQuotation = payload;
      state.listOfficeQuotation.push(DEFAULT_OFFICE_QUOTATION);
    },
    setItemsInsuranceToEmail(state, payload) {
      state.itemsInsuranceToEmail = payload;
    },
    setCurrentSelectFilterRequestEndorsement(state, payload) {
      state.currentSelectFilterRequestEndorsement = payload;
    },
    setCafezalEspecieOptions(state, payload) {
      state.cafezalEspecieOptions = payload;
    },
    setCafezalVariedadeOptions(state, payload) {
      state.cafezalVariedadeOptions = payload;
    },
    setCafezalSistemaCultivoOptions(state, payload) {
      state.cafezalSistemaCultivoOptions = payload;
    },
    setListBankingInstitutions(state, payload) {
      state.listBankingInstitutions = payload;
    }
  },
  actions: {
    saveValueStepModality({ commit, dispatch }, payload) {
      commit("setValueStepModality", payload.valueModality);
      dispatch("updateCurrentQuotationStep", payload.nextStep);
    },
    updateCurrentQuotationStep({ commit }, payload) {
      commit("setCurrentQuotationStep", payload);
    },
    async updateFavoriteCompaniesList({ commit }, payload) {
      const { data } = await API.putFavoriteCompany(payload);
      commit("updateTakerList", payload.item);
      return data;
    },
    saveCompaniesQuotation({ commit }, payload) {
      commit("setEconomicGroupQuotation", payload.economicGroup);
      commit("setTakerQuotation", payload.taker);
    },
    saveInsuredForm({ commit, dispatch }, payload) {
      commit("setInsuredForm", payload.formInsured);
      dispatch("updateCurrentQuotationStep", payload.nextStep);
    },
    saveSelectedResource({ commit }, payload) {
      commit("setResourceQuotation", payload);
    },
    saveResourceForm({ commit, dispatch }, payload) {
      commit("setResourceForm", payload.formResource);
      dispatch("updateCurrentQuotationStep", payload.nextStep);
    },
    async requestHistoricalActionsApiCalls({ commit }, payload) {
      const { data } = await API.getApiCalls(payload);
      commit("setApiCalls", data);
      return data;
    },
    async requestEconomicGroup({ commit }, payload) {
      const { data } = await API.getEconomicGroup(payload);
      commit("setListEconomicGroup", data);
      return data;
    },
    async requestTaker({ commit }, payload) {
      const { data } = await API.getTaker(payload);
      commit("setListTaker", data);
      return data;
    },
    async requestUserTaker({ commit }) {
      const { data } = await API.getUserTaker();
      commit("setListUserTaker", data);
      return data;
    },
    async requestResourceType({ commit }) {
      const { data } = await API.getResourceType();
      commit("setListResourceType", data);
      return data;
    },
    async requestInsuredByNameOrCPFCNPJ({ commit }, payload) {
      const { data } = await API.getInsured(payload);
      commit("setInsuredByNameOrCPFCNPJ", data);
      return data;
    },
    async requestAddressApi({ commit }, payload) {
      const { data } = await API.getAddressApi(payload);
      commit("setAddressApi", data);
      return data;
    },
    async requestListQuotation({ commit }, payload) {
      const { data } = await API.getListQuotation(payload);
      // total de items que terão na data-table de
      // lista de cotações
      commit("setListQuotation", data);
      return data;
    },
    async requestListClassificacaoSolo({ commit }, payload) {
      const { data } = await API.getListClassificacaoSolo(payload);
      commit("setListClassificacaoSolo", data);
      return data;
    },
    async requestSubModalities({ commit }, payload) {
      const { data } = await API.getSubModalities(payload);
      commit("setListSubModality", data);
      return data;
    },
    async requestModalities({ commit }) {
      const { data } = await API.getModalities();
      commit("setListModality", data);
      return data;
    },
    async requestEgModalities({ commit }, payload) {
      const { data } = await API.getEgModalities(payload);
      commit("setListModality", data);
      return data;
    },
    async requestNumberProcess({ commit }, payload) {
      const { data } = await API.getNumberProcess(payload);
      commit("setEletronicProcessValue", data);
      return data;
    },
    async requestJusticeRegion({ commit }, payload) {
      const { data } = await API.getJusticeRegion(payload);
      commit("setListJusticeRegion", data);
      return data;
    },
    async requestCourtJustice({ commit }, payload) {
      const { data } = await API.getCourtJustice(payload);
      commit("setListCourtJustice", data);
      return data;
    },
    async requestDeadlineByTaker({ commit }, payload) {
      const { data } = await API.getDeadlineByTaker(payload);
      commit("setListDeadlineByTaker", data);
      return data;
    },
    async makeNewQuotation({ commit }, payload) {
      const { data } = await API.postNewQuotation(payload);
      commit("setInfoCostQuotation", data);
      return data;
    },
    async makeNewQuotationAgro({ commit }, payload) {
      const { data } = await API.postNewQuotationAgro(payload);
      commit("setInfoCostQuotation", data);
      return data;
    },
    //Chama a api para trazer log da cotação agro.
    async requestJsonQuotationAgro({ commit }, idQuotation) {
      const { data } = await API.requestLogQuotationAgro(idQuotation);
      commit("setInfoCostQuotation", data);
      return data;
    },
    //Envia o custos da cotação agro.
    async postQuotationCostsAgro({ commit }, payload) {
      const { data } = await API.postQuotationCostsAgro(payload);
      commit("setInfoCostQuotation", data);
      return data;
    },
    //Traz a lista de custo da cotação agro.
    async requestListQuotationCostsAgro({ commit }, payload) {
      const { data } = await API.getListQuotationCostsAgro(payload);
      commit("setListQuotationCostsAgro", data);
      return data;
    },
    //traz um único custo da cotação agro selecionado.
    async requestQuotationCostsAgro({ commit }, payload) {
      const { data } = await API.getQuotationCostsAgro(payload);
      commit("setInfoCostQuotation", data);
      return data;
    },
    //envia dados da contratação agro após ser aprovado o custo.
    async makeContractDataQuotationAgro({ commit }, payload) {
      const { data } = await API.postContractDataQuotationAgro(payload);
      commit("setInfoCostQuotation", data);
      return data;
    },
    async requestCurrentQuotation({ commit }, payload) {
      const { data } = await API.getCurrentQuotation(payload);
      commit("setCurrentQuotation", data);
      return data;
    },
    async requestCurrentQuotationAgro({ commit }, payload) {
      const { data } = await API.getCurrentQuotationAgro(payload);
      commit("setCurrentQuotation", data);
      return data;
    },
    async requestCancelQuotationAgro({ commit }, payload) {
      const { data } = await API.putCancelQuotationAgro(payload);
      commit("setCurrentQuotation", data);
      return data;
    },
    async requestCourtQuotation({ commit }, payload) {
      const { data } = await COMMON_API.getCourt(payload);
      commit("setCurrentAutoCompleteFilterQuotation", data);
      return data;
    },
    async requestEconomicGroupQuotation({ commit }, payload) {
      const { data } = await COMMON_API.getEconomicGroup(payload);
      commit("setCurrentAutoCompleteFilterQuotation", data);
      return data;
    },
    async requestInsuredQuotation({ commit }, payload) {
      const { data } = await COMMON_API.getInsured(payload);
      commit("setCurrentAutoCompleteFilterQuotation", data);
      return data;
    },
    async requestNumberQuotation({ commit }, payload) {
      const { data } = await COMMON_API.getQuotation(payload);
      commit("setCurrentAutoCompleteFilterQuotation", data.items);
      return data;
    },
    async requestListQuotationAgro({ commit }, payload) {
      const { data } = await COMMON_API.getQuotationAgro(payload);
      commit("setListQuotationAgro", data);
      return data;
    },
    async requestListPropostaAgro({ commit }, payload) {
      const { data } = await COMMON_API.getPropostaAgro(payload);
      commit("setListPropostaAgro", data);
      return data;
    },
    async requestListApoliceAgro({ commit }, payload) {
      const { data } = await COMMON_API.getApoliceAgro(payload);
      commit("setListApoliceAgro", data);
      return data;
    },
    async requestTakerQuotation({ commit }, payload) {
      const { data } = await COMMON_API.getTaker(payload);
      commit("setCurrentTakerQuotation", data);
      return data;
    },
    async requestInsuranceCompanyQuotation({ commit }, payload = null) {
      const { data } = await COMMON_API.getInsuranceCompanies();
      // Para evitar de replicar dispatch, commit e methods,
      // Foi adicionado o item payload para saber qual state
      // será salvo a lista referente ao filtro
      if (payload) {
        commit("setCurrentSelectFilterRequestEndorsement", data);
      } else {
        commit("setCurrentSelectFilterQuotation", data);
      }
      return data;
    },
    async fetchInsuranceCompany({ commit }, payload = null) {
      // caso tenha payload e uma cotação aberta, usará o grupo economico da cotação para filtrar as seguradoras
      if (payload) {
        payload.grupoEconomicoId = this.state.quotation?.currentQuotation?.grupo_economico?.id ?? '';
      }
      const { data } = await COMMON_API.getInsuranceCompanies(payload);
      commit("setInsuranceCompanyOptions", data);
      return data;
    },
    async requestModalityQuotation({ commit }, payload = null) {
      const { data } = await COMMON_API.getModalities();
      // Para evitar de replicar dispatch, commit e methods,
      // Foi adicionado o item payload para saber qual state
      // será salvo a lista referente ao filtro
      if (payload) {
        commit("setCurrentSelectFilterRequestEndorsement", data);
      } else {
        commit("setCurrentSelectFilterQuotation", data);
      }
      return data;
    },
    async requestSubModalityQuotation({ commit }, payload = null) {
      const { data } = await COMMON_API.getSubModalities();
      // Para evitar de replicar dispatch, commit e methods,
      // Foi adicionado o item payload para saber qual state
      // será salvo a lista referente ao filtro
      if (payload) {
        commit("setCurrentSelectFilterRequestEndorsement", data);
      } else {
        commit("setCurrentSelectFilterQuotation", data);
      }
      return data;
    },
    resetCurrentFilters({ state }, payload = null) {
      // Para evitar de replicar dispatch, commit e methods,
      // Foi adicionado o item payload para saber qual state
      // será salvo a lista referente ao filtro
      state.currentAutoCompleteFilterQuotation = [];
      if (payload) {
        state.currentSelectFilterRequestEndorsement = [];
      } else {
        state.currentSelectFilterQuotation = [];
      }
    },
    async requestListCriticism({ commit }, payload) {
      const { data } = await API.getListCriticism(payload);
      commit("setListCriticism", data);
      return data;
    },
    async requestNewCriticism(context, payload) {
      const { data } = await API.postCriticism(payload);
      return data;
    },
    async requestResendCriticism(context, payload) {
      const { data } = await API.postResendCriticism(payload);
      return data;
    },
    async requestResolveCriticism(context, payload) {
      const { data } = await API.putResolveCriticism(payload);
      return data;
    },
    async requestEditQuotation(context, payload) {
      const { data } = await API.putQuotation(payload);
      return data;
    },
    async requestCurrentQuotationToEdit({ commit }, payload) {
      const { data } = await API.getCurrentQuotationToEdit(payload);
      commit("setCurrentQuotationToEdit", data);
      return data;
    },
    async requestYearsAccordingEconomicGroup({ commit }, payload) {
      const { data } = await API.getYearsAccordingEconomicGroup(payload);
      commit("setCurrentYearsQuotation", data);
      return data;
    },
    async requestNewDraftContract(context, payload) {
      const { data } = await API.postDraftContract(payload);
      return data;
    },
    async requestSolicitDraftContract({ commit }, payload) {
      const { data } = await API.putSolicitDraftContract(payload);
      commit("setCurrentQuotation", data);
      return data;
    },
    async requestApproveDraftContract({ commit }, payload) {
      const { data } = await API.putApproveDraftContract(payload);
      commit("setCurrentQuotation", data);
      return data;
    },
    async requestSolicitApproveDraftContract({ commit }, payload) {
      const { data } = await API.putSolicitApproveDraftContract(payload);
      commit("setCurrentQuotation", data);
      return data;
    },
    async requestSolicitPolicyContract({ commit }, payload) {
      const { data } = await API.putSolicitPolicyContract(payload);
      commit("setCurrentQuotation", data);
      return data;
    },
    async requestRejectDraftContract({ commit }, payload) {
      const { data } = await API.putRejectDraftContract(payload);
      commit("setCurrentQuotation", data);
      return data;
    },
    async requestAddChosenInsuranceInQuotation({ commit }, payload) {
      const { data } = await API.putChosenInsuranceInQuotation(payload);
      commit("setCurrentQuotation", data);
      return data;
    },
    async requestCancelQuotation({ commit }, payload) {
      const { data } = await API.putCancelQuotation(payload);
      commit("setCurrentQuotation", data);
      return data;
    },
    async requestNewPolicy(context, payload) {
      const { data } = await API.postPolicyContract(payload);
      return data;
    },
    async requestHistoricalActions({ commit }, payload) {
      const { data } = await API.getHistoricalActions(payload);
      commit("setCurrentHistoricalActions", data);
      return data;
    },
    async requestDeclineDraftContract({ commit }, payload) {
      const { data } = await API.putDeclineDraftContract(payload);
      commit("setCurrentQuotation", data);
      return data;
    },
    updateSelectFilterQuotation({ state }, payload) {
      state.currentSelectFilterQuotation.push(payload);
    },
    async requestItemsCriticism({ commit }, payload) {
      const { data } = await API.getItemsCriticism(payload);
      commit("setItemsCriticism", data);
      return data;
    },
    async requestStatusCurrentQuotation({ commit }, payload) {
      const { data } = await API.getStatusCurrentQuotation(payload);
      commit("setStatusCurrentQuotation", data);
      return data;
    },
    async requestOfficeByEconomicGroup({ commit }, payload) {
      const { data } = await API.getListOfficeQuotation(payload);
      commit("setListOfficeQuotation", data);
      return data;
    },
    async requestStatusQuotation({ commit }) {
      const { data } = await COMMON_API.getStatusQuotation();
      commit("setCurrentSelectFilterQuotation", data);
      return data;
    },
    async requestStatusPolicy({ commit }) {
      const { data } = await COMMON_API.getStatusPolicy();
      commit("setCurrentSelectFilterQuotation", data);
      return data;
    },
    async requestNumberPolicy({ commit }, payload) {
      const { data } = await COMMON_API.getPolicy(payload);
      commit("setCurrentAutoCompleteFilterQuotation", data.items);
      return data;
    },
    async requestOptionsQuotation(context, payload) {
      const { data } = await API.getOptionsQuotation(payload);
      return data;
    },
    async requestRefuseDrafContractQuotation({ commit }, payload) {
      const { data } = await API.putRefuseDrafContractQuotation(payload);
      commit("setCurrentQuotation", data);
      return data;
    },
    async requestDraftContractQuotation({ commit }, payload) {
      const { data } = await API.putRequestDraftContractQuotation(payload);
      commit("setCurrentQuotation", data);
      return data;
    },
    async requestApproveDraftContractQuotation({ commit }, payload) {
      const { data } = await API.putApproveDraftContractQuotation(payload);
      commit("setCurrentQuotation", data);
      return data;
    },
    //Custo da Cotação escolhida Agro
    async requestApproveDraftContractQuotationAgro({ commit }, value) {
      const { data } = await API.putApproveDraftContractQuotationAgro(value);
      commit("setCurrentQuotationAgro", data);
      return data;
    },
    //Aprova Custo da Cotação escolhida cafezal
    async requestApproveDraftContractQuotationCafezal({ commit }, value) {
      const { data } = await API.putApproveDraftContractQuotationCafezal(value);
      commit("setCurrentQuotationAgro", data);
      return data;
    },

    //Atualiza os documentos quando sai da proposta e entra na tela conformidade agro.
    async requestAgroAgreement(context, payload) {
      const { data } = await API.putAgroAgreement(payload);
      return data;
    },

    //Atualiza os documentos quando sai da proposta e entra na tela conformidade cafezal.
    async requestCafezalAgreement(context, payload) {
      const { data } = await API.putCafezalAgreement(payload);
      return data;
    },

    //Envio dos arquivos agro.
    async requestUploadAgroAgreement(context, payload) {
      const { data } = await API.postUploadAgroAgreement(payload);
      return data;
    },

    //Envio dos arquivos cafezal.
    async requestUploadCafezalAgreement(context, payload) {
      const { data } = await API.postUploadCafezalAgreement(payload);
      return data;
    },

    //atualização do card
    async requestCardAgroAgreement(context, payload) {
      const { data } = await API.getUploadAgroAgreement(payload);
      return data;
    },

    //Aprovação da conformidade cotação agro.
    async requestApproveUploadAgroAgreement({ commit }, value) {
      const { data } = await API.putApproveUploadAgroAgreement(value);
      commit("setCurrentQuotation", data);
      return data;
    },

    async requestRejectUploadAgroAgreement({ commit }, value) {
      const { data } = await API.putRejectUploadAgroAgreement(value);
      commit("setCurrentQuotation", data);
      return data;
    },
    async submitProposalAgro({ commit }, payload) {
      const { data } = await API.putProposalAgro(payload);
      commit("setCurrentQuotationAgro", data);
      return data;
    },
    async submitProposalCafezal({ commit }, payload) {
      const { data } = await API.putProposalCafezal(payload);
      commit("setCurrentQuotationAgro", data);
      return data;
    },
    async submitPolicyDataAgro({ commit }, payload) {
      const { data } = await API.putPolicyAgro(payload);
      commit("setCurrentQuotationAgro", data);
      return data;
    },
    async submitPolicyDataCafezal({ commit }, payload) {
      const { data } = await API.putPolicyCafezal(payload);
      commit("setCurrentQuotationAgro", data);
      return data;
    },
    async requestApprovalDraftContractQuotation({ commit }, payload) {
      const { data } = await API.putApprovalDraftContractQuotation(payload);
      commit("setCurrentQuotation", data);
      return data;
    },
    async requestEditCostQuotation({ commit }, payload) {
      const { data } = await API.putCostQuotation(payload);
      commit("setCurrentQuotation", data);
      return data;
    },
    async requestDeclineCostQuotation({ commit }, payload) {
      const { data } = await API.putDeclineCostQuotation(payload);
      commit("setCurrentQuotation", data);
      return data;
    },
    async requestItemsInsuranceToEmail({ commit }, payload) {
      const { data } = await API.getItemsInsuranceToEmail(payload);
      commit("setItemsInsuranceToEmail", data);
      return data;
    },
    async requestSendEmailInsuranceQuotation({ commit }, payload) {
      const { data } = await API.postEmailInsuranceQuotation(payload);
      commit("setCurrentQuotation", data.cotacao);
      return data;
    },
    async requestRemoveDraftContractQuotation({ commit }, payload) {
      const { data } = await API.putRemoveDraftContractQuotation(payload);
      commit("setCurrentQuotation", data);
      return data;
    },
    async requestReactivateCostQuotation({ commit }, payload) {
      const { data } = await API.putReactivateCostQuotation(payload);
      commit("setCurrentQuotation", data);
      return data;
    },
    async requestTypeEndorsementQuotation({ commit }, payload = null) {
      const { data } = await COMMON_API.getTypesEndorsement();
      // Para evitar de replicar dispatch, commit e methods,
      // Foi adicionado o item payload para saber qual state
      // será salvo a lista referente ao filtro
      if (payload) {
        commit("setCurrentSelectFilterRequestEndorsement", data);
      } else {
        commit("setCurrentSelectFilterQuotation", data);
      }
      return data;
    },
    async requestStatusEndorsementQuotation({ commit }, payload = null) {
      const { data } = await COMMON_API.getStatusEndorsement();
      // Para evitar de replicar dispatch, commit e methods,
      // Foi adicionado o item payload para saber qual state
      // será salvo a lista referente ao filtro
      if (payload) {
        commit("setCurrentSelectFilterRequestEndorsement", data);
      } else {
        commit("setCurrentSelectFilterQuotation", data);
      }
      return data;
    },
    async fetchCafezalEspecieOptions({ commit }, payload) {
      const { data } = await API.getCafezalEspecieOptions(payload);
      commit("setCafezalEspecieOptions", data);
      return data;
    },
    async fetchCafezalVariedadeOptions({ commit }, payload) {
      const { data } = await API.getCafezalVariedadeOptions(payload);
      commit("setCafezalVariedadeOptions", data);
      return data;
    },
    async fetchCafezalSistemaCultivoOptions({ commit }, payload) {
      const { data } = await API.getCafezalSistemaCultivoOptions(payload);
      commit("setCafezalSistemaCultivoOptions", data);
      return data;
    },
    async requestBankingInstitutions({ commit }, payload) {
      const { data } = await API.getBanksList(payload);
      commit("setListBankingInstitutions", data);
      return data;
    }
  },
  modules: {}
};
